import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../globals';
import { Configuration } from '../app.configuration';

declare var jQuery: any;
export class User {
  constructor() {}
}

@Injectable()
export class LoginService {
  private _languages = myGlobals.apiurl + 'utility/languages';
  private _loginUrl = myGlobals.apiurl + 'customer/signIn';
  private _loginUrlPartner = myGlobals.apiurl + 'partner/signIn';
  private _checkmail = myGlobals.apiurl + 'customer/emailValidation';
  private _checkphone = myGlobals.apiurl + 'customer/phoneValidation';
  private _signotp = myGlobals.apiurl + 'customer/verifyVerificationCode';
  private _verifyotp = myGlobals.apiurl + 'customer/verifyPhoneNumber';
  private _otpresend = myGlobals.apiurl + 'customer/resendOtp';
  private _signup = myGlobals.apiurl + 'customer/signUp';
  private _referralcode = myGlobals.apiurl + 'customer/referralCodeValidation';
  private _forgotpassword = myGlobals.apiurl + 'customer/forgotPassword';
  private _updatepassword = myGlobals.apiurl + 'customer/password';
  private _images = myGlobals.apiurl + 'utility/uploadImage';

  constructor(private _http: HttpClient, private _conf: Configuration) {}

  uploadImages(fileToUpload) {
    const formData = new FormData();
    formData.append('image', fileToUpload);
    return this._http.post(this._images, formData);
  }

  login(user: any) {
    if (user.type) {
      delete user.type;
      return this._http.post(this._loginUrl, user, {
        headers: this._conf.header
      });
    } else {
      const userObj = {
        email: user.emailOrPhone,
        password: user.password,
        roleType: 1
      };
      return this._http.post(this._loginUrlPartner, userObj, {
        headers: this._conf.header
      });
    }
  }

  verifymail(user: any) {
    return this._http.post(this._checkmail, user, {
      headers: this._conf.header
    });
  }
  verifyphone(user: any) {
    return this._http.post(this._checkphone, user, {
      headers: this._conf.header
    });
  }
  signupotp(user: any) {
    return this._http.post(this._signotp, user, { headers: this._conf.header });
  }
  signupotpresend(user: any) {
    return this._http.post(this._otpresend, user, {
      headers: this._conf.header
    });
  }
  verifyotp(user: any) {
    return this._http.post(this._verifyotp, user, {
      headers: this._conf.header
    });
  }
  signupcall(user: any) {
    return this._http.post(this._signup, user, { headers: this._conf.header });
  }
  promocode(user: any) {
    return this._http.post(this._referralcode, user, {
      headers: this._conf.header
    });
  }
  forgotPass(user: any) {
    return this._http.post(this._forgotpassword, user, {
      headers: this._conf.header
    });
  }
  updatePass(user: any) {
    return this._http.patch(this._updatepassword, user, {
      headers: this._conf.header
    });
  }
  getLanguages() {
    return this._http.get(this._languages);
  }
}
